<div class="testimonials-outer-wrapper">
    <div class="testimonials-wrapper">
        <div class="testimonial" *ngFor="let testimonial of testimonials">
            <div class="testimonial-pic">
                <img src="{{testimonial?.image}}">
            </div>
            <div class="testimonial-detail">
                <div class="testimonial-text">
                    {{testimonial?.text}}
                </div>
                <div class="testimonial-ratings">
                    <ul class="rating">
                        <li class="fas fa-star"></li>
                        <li class="fas fa-star"></li>
                        <li class="fas fa-star"></li>
                        <li class="far fa-star"></li>
                        <li class="far fa-star"></li>
                    </ul>
                </div>
                <div class="testimonial-giver">
                    Name Goes here
                </div>
            </div>
        </div>
    </div>
</div>
